// mixins/homeMixin.js

import { mapGetters } from "vuex";

export default {
    computed: {
        ...mapGetters([
            'projects',
            'calloutLoading',
            'deptLoading',
            'ongoingCallouts',
            'openIssues',
            'recentMaintenances',
            'openIssuesLoading',
            'maintenancesLoading',
            'userDetails',
            'isMobile',
            'getters'
        ])
    }
}
